import { adminFetch } from "./_client";
import type { Conversion48hSnapshot, SystemHealthStatus, AlgoliaIndexHealth, AbandonedCheckoutRecoveryHealth, WinBackFunnelStats, BadgeCounts, RatingRecalcResult } from "./types";


export function fetchConversion48h(token: string) {
  return adminFetch<Conversion48hSnapshot>("/admin/dashboard/conversion-48h", token);
}


export function fetchSystemHealth(token: string) {
  return adminFetch<SystemHealthStatus>("/admin/dashboard/system-health", token);
}


export function fetchAlgoliaHealth(token: string) {
  return adminFetch<AlgoliaIndexHealth>("/admin/dashboard/algolia-health", token);
}


export function fetchAbandonedCheckoutRecoveryHealth(token: string) {
  return adminFetch<AbandonedCheckoutRecoveryHealth>("/admin/dashboard/abandoned-checkout-recovery", token);
}


export function fetchWinBackFunnelStats(token: string) {
  return adminFetch<WinBackFunnelStats>("/admin/analytics/win-back-funnel", token);
}


export function fetchBadgeCounts(token: string) {
  return adminFetch<BadgeCounts>("/admin/dashboard/badge-counts", token);
}

export interface AdminNotificationSummary {
  unread: number;
  notifications: Array<{
    id: number; type: string | null; message: string | null;
    is_read: boolean; action_url: string | null; created_at: string;
  }>;
}

export function fetchMyAdminNotifications(token: string) {
  return adminFetch<AdminNotificationSummary>("/admin/dashboard/my-notifications", token);
}


export function triggerRatingRecalculate(token: string) {
  return adminFetch<RatingRecalcResult>("/admin/tools/rating-recalculate", token, { method: "POST" });
}
